module.exports = __webpack_public_path__ + "img/background.af2839ce.png";